const options = {
    navTabs: ".nav-tabs a",
    tabContent: ".tab-content .tab-item",
    tabPanel: ".tab-panel"
};

var BlsTab = (function(){
     return {
      eventProductTabs: function () {
        document.querySelectorAll(options.navTabs).forEach((tabToggle) => {
          tabToggle.addEventListener("click", (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const tab_id = target.getAttribute("data-block-id");
            
            document.querySelectorAll(".data.item").forEach(item => {
              item.classList.remove("active");
            });
            
            document.querySelectorAll(options.tabPanel).forEach(panel => {
              panel.style.display = "none";
            });
            
            document.querySelectorAll(options.tabContent).forEach(item => {
              item.classList.remove("active");
            });
            
            target.closest(".data.item").classList.add("active");

            // Custom retornam 2 nodes (não deveria pois é um id)
            //console.log(document.querySelectorAll(`#${tab_id}`))
            const contentTabCustom = document.querySelectorAll(`#${tab_id}`).item(1);

            const contentTabDescription = document.getElementById(tab_id)

            const contentTab = contentTabCustom ? contentTabCustom : contentTabDescription
            
            if (contentTab) {
              contentTab.classList.add("active");
              const panel = contentTab.querySelector(options.tabPanel);
              if (panel) panel.style.display = "block";
            }
          }, false);
        });
      }
     }
})();

document.addEventListener("DOMContentLoaded", function() {
  BlsTab.eventProductTabs();
});